import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

export function getListApi({ employeeId, teamId, tagType, pageType }) {
  const url = endpoints.developments.list(employeeId);
  const queryParams = { teamId, tagType, pageType };
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams,
  });
}

export function getDetailApi({ employeeId, employeeMappingId, pageType }) {
  const url = endpoints.developments.detail(employeeId, employeeMappingId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      pageType,
    },
  });
}

export function getProgressApi({ employeeId }) {
  const url = endpoints.developments.progress(employeeId);

  return sendRequest({
    url,
    method: 'GET',
  });
}

export function getFeedbackApi({ employeeId, limit = 8, offset = 0, tagId, type }) {
  const url = endpoints.developments.feedback(employeeId, tagId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      sentimentType: type,
    },
  });
}

export function getFeedbackApiV1({ employeeId, limit = 8, offset = 0, tagId, feedbackType }) {
  const url = endpoints.developments.feedbackV1(employeeId, tagId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      feedback_type: feedbackType,
    },
  });
}

export function getAllFeedbackApi({ employeeId, limit = 8, offset = 0, tagId, feedbackType }) {
  const url = endpoints.developments.allFeedback;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      feedback_type: feedbackType,
      emp_id: employeeId,
    },
  });
}

export function getMiscellaneousFeedbackApi({ employeeId, limit = 8, offset = 0, feedbackType }) {
  const url = endpoints.developments.miscellaneousCompetencyFeedback(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      feedback_type: feedbackType,
    },
  });
}

export function getListV1Api({ employeeId, teamId, tagType, includeMiscellaneous = false }) {
  const url = endpoints.developments.listV1(employeeId);
  const queryParams = { teamId, tagType, include_miscellaneous: includeMiscellaneous };
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams,
  });
}

export function getAllStatsApi({ employeeId }) {
  const url = endpoints.developments.allStats;
  const queryParams = { emp_id: employeeId };
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams,
  });
}

export function getCompetencyStatsApi({ employeeId, competencyId }) {
  const url = endpoints.developments.competencyStats(employeeId, competencyId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
}
